module.exports = __webpack_public_path__ + "img/logo.2712029c.png";